export default "__VITE_ASSET__e36160dc__"